import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import PasswordDialog from './PasswordDialog';
import { useT } from '../i18n/i18n';

export default function DeleteAccountDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { token, logout } = useAuth();
  const nav = useNavigate();
  const t = useT();

  async function deleteAccount(password: string) {
    await api<void>('/me/account/delete', { method: 'POST', token, body: { password } });
    onClose();
    logout();
    nav('/login', { replace: true });
  }

  return (
    <PasswordDialog
      open={open}
      title={t('Delete your account')}
      message={t('This removes your sign-in, every learner on this account, their programs and everything recorded about their practice. It cannot be undone. Enter your password to confirm.')}
      confirmLabel={t('Delete everything')}
      onConfirm={deleteAccount}
      onCancel={onClose}
    />
  );
}
